import { type TAvatarType } from '@cian/ui-kit';

import { type TType as TPublisherAvatarType } from '@/repositories/generated/shared/search-offers/entities/publisher/PublisherSchema';

export function getPublisherAvatarType(type: TPublisherAvatarType | null): TAvatarType | null {
  switch (type) {
    case 'agent':
      return 'agent';
    case 'yeoman':
      return 'user';
    case 'coworkingOperator':
    case 'agency':
      return 'agency';
    case 'landlord':
      return 'homeowner';
    default:
      return null;
  }
}
